module.exports = __webpack_public_path__ + "app/images/about/all-hands20-2.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/about/all-hands20-2.png
// module id = 440
// module chunks = 0